import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Nav from "./Nav";
import Footer from "./Footer";

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="App min-h-screen bg-[#0B0B0B] text-white">
      <Nav />
      <main data-testid="page-main">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
